/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_PastInputs */

const th_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่ผ่านมา`)
};

const en_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past`)
};

const ja_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去`)
};

const zh_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已结束`)
};

const es_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasados`)
};

const pt_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteriores`)
};

const id_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lampau`)
};

const fr_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passés`)
};

const tl_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraan`)
};

const vi_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã qua`)
};

const ko_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지난`)
};

const de_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene`)
};

const ru_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедшие`)
};

const tr_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçmiş`)
};

const it_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passati`)
};

const pl_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minione`)
};

const uk_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минулі`)
};

const hi_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीते`)
};

const ar_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سابقة`)
};

const ms_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepas`)
};

const bn_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অতীত`)
};

const zh_tw2_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const zh_hk2_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const ur_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گزشتہ`)
};

const fa_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گذشته`)
};

const sw_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaliyopita`)
};

const nl_tab_past = /** @type {(inputs: Tab_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbij`)
};

/**
* | output |
* | --- |
* | "Past" |
*
* @param {Tab_PastInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_past = /** @type {((inputs?: Tab_PastInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_PastInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_past(inputs)
	if (locale === "ja") return ja_tab_past(inputs)
	if (locale === "zh") return zh_tab_past(inputs)
	if (locale === "es") return es_tab_past(inputs)
	if (locale === "pt") return pt_tab_past(inputs)
	if (locale === "id") return id_tab_past(inputs)
	if (locale === "fr") return fr_tab_past(inputs)
	if (locale === "tl") return tl_tab_past(inputs)
	if (locale === "vi") return vi_tab_past(inputs)
	if (locale === "ko") return ko_tab_past(inputs)
	if (locale === "de") return de_tab_past(inputs)
	if (locale === "ru") return ru_tab_past(inputs)
	if (locale === "tr") return tr_tab_past(inputs)
	if (locale === "it") return it_tab_past(inputs)
	if (locale === "pl") return pl_tab_past(inputs)
	if (locale === "uk") return uk_tab_past(inputs)
	if (locale === "hi") return hi_tab_past(inputs)
	if (locale === "ar") return ar_tab_past(inputs)
	if (locale === "ms") return ms_tab_past(inputs)
	if (locale === "bn") return bn_tab_past(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_past(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_past(inputs)
	if (locale === "ur") return ur_tab_past(inputs)
	if (locale === "fa") return fa_tab_past(inputs)
	if (locale === "sw") return sw_tab_past(inputs)
	if (locale === "nl") return nl_tab_past(inputs)
	return en_tab_past(inputs)
});